module.exports = __webpack_public_path__ + "static/media/level-perfect.9a9989e6.png";


//////////////////
// WEBPACK FOOTER
// ./src/rating/img/level-perfect.png
// module id = 2089
// module chunks = 0